import React from "react";
import { DatePicker } from "@bst/react-ui";
import { useTranslation } from "react-i18next";

import { SettingsTitle } from "./../Components/SettingsTitle";
import { SettingsContainer } from "./../Components/SettingsContainer";
import { useNLMModelRunDetails } from "../Hooks/useNLMModelRunDetails";
import SkeletonBlock from "../../Skeletons/SkeletonBlock";
import { Select } from '../../FormControls/Select';
import { FormLabel } from '../../FormControls/FormLabel';

/**
 * NLM Run Details section of Insights App Settings
 * @returns NLM Run Details section of Insights App Settings
 */
export const NLMModelRunDetails = () => {
  const { t } = useTranslation();
  const {
    startDate,
    runFrequency,
    defaultRunFrequency,
    modelRunFrequencies,
    setRunFrequency,
    handleStartDateChange,
    isLoading,
    minDate
  } = useNLMModelRunDetails();
  return (
    <SettingsContainer className="model-run-details">
      <SettingsTitle>{t("nlmsettings.modelRunDetails")}</SettingsTitle>
      {isLoading ? (
        <div className="model-run-details__row">
          <div className="model-run-details__skeleton">
            <SkeletonBlock width={"40%"} height={9} />
            <SkeletonBlock width={"100%"} height={14} />
          </div>
          <div className="model-run-details__skeleton">
            <SkeletonBlock width={"40%"} height={9} />
            <SkeletonBlock width={"100%"} height={14} />
          </div>
          <div className="model-run-details__skeleton"></div>
        </div>
      ) : (
        <div className="model-run-details__row">
          <Select
            disabled
            label={t("nlmsettings.modelRunFrequency")}
            value={runFrequency}
            options={modelRunFrequencies}
            onChange={(value) =>
              setRunFrequency((value as number) || defaultRunFrequency)
            }
          />
          <DatePicker
            closeOnSelect
            showTodayButton
            label={t("nlmsettings.startDate")}
            className="model-run-details-datepicker"
            minDate={minDate}
            selected={startDate}
            onSelect={(date) => handleStartDateChange(date)}
          />
          <div
            className="model-run-details__form-control"
            style={{ opacity: 0 }}
          >
            <FormLabel>{t("nlmsettings.startTime")}</FormLabel>
          </div>
        </div>
      )}
    </SettingsContainer>
  );
};
